// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-fields {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
}

.map-fields-header {
  text-align: center;
  margin-bottom: 40px;
}

.map-fields-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.map-fields-header p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.6;
}

.mapping-section {
  max-width: 1000px;
  margin: 0 auto 40px;
}

.section-header {
  margin-bottom: 30px;
}

.section-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 10px;
}

.section-header p {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

.field-mapping-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.field-headers {
  display: grid;
  grid-template-columns: 1fr 1fr 60px;
  gap: 20px;
  padding: 20px 30px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.field-headers h3 {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.field-mappings {
  padding: 0;
}

.field-mapping-row {
  display: grid;
  grid-template-columns: 1fr 1fr 60px;
  gap: 20px;
  padding: 20px 30px;
  border-bottom: 1px solid #f3f4f6;
  align-items: center;
}

.field-mapping-row:last-child {
  border-bottom: none;
}

.field-select-container {
  position: relative;
}

.field-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  background: #f9fafb;
  color: #1f2937;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 16px;
  padding-right: 40px;
}

.field-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background: white;
}

.field-select:hover {
  background: white;
  border-color: #9ca3af;
}

.hubspot-field {
  background: #f0f9ff;
}

.salesforce-field {
  background: #fef3c7;
}

.delete-mapping-btn {
  width: 40px;
  height: 40px;
  border: none;
  background: #fee2e2;
  color: #dc2626;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.delete-mapping-btn:hover {
  background: #fecaca;
  color: #b91c1c;
}

.add-mapping-section {
  padding: 20px 30px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.add-mapping-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-mapping-btn:hover {
  background: #2563eb;
}

.actions-section {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 1000px;
  margin: 0 auto;
}

.back-button,
.continue-button {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.back-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.continue-button {
  background: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.continue-button:hover {
  background: #2563eb;
  border-color: #2563eb;
}

@media (max-width: 768px) {
  .map-fields {
    padding: 20px;
  }

  .field-headers,
  .field-mapping-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .field-headers {
    text-align: center;
  }

  .field-mapping-row {
    position: relative;
    padding-bottom: 60px;
  }

  .delete-mapping-btn {
    position: absolute;
    bottom: 15px;
    right: 30px;
  }

  .actions-section {
    flex-direction: column;
  }

  .back-button,
  .continue-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/MapFields.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".map-fields {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n}\n\n.map-fields-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.map-fields-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.map-fields-header p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 8px;\n  line-height: 1.6;\n}\n\n.mapping-section {\n  max-width: 1000px;\n  margin: 0 auto 40px;\n}\n\n.section-header {\n  margin-bottom: 30px;\n}\n\n.section-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 10px;\n}\n\n.section-header p {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.field-mapping-container {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.field-headers {\n  display: grid;\n  grid-template-columns: 1fr 1fr 60px;\n  gap: 20px;\n  padding: 20px 30px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.field-headers h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n.field-mappings {\n  padding: 0;\n}\n\n.field-mapping-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 60px;\n  gap: 20px;\n  padding: 20px 30px;\n  border-bottom: 1px solid #f3f4f6;\n  align-items: center;\n}\n\n.field-mapping-row:last-child {\n  border-bottom: none;\n}\n\n.field-select-container {\n  position: relative;\n}\n\n.field-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  background: #f9fafb;\n  color: #1f2937;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  padding-right: 40px;\n}\n\n.field-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  background: white;\n}\n\n.field-select:hover {\n  background: white;\n  border-color: #9ca3af;\n}\n\n.hubspot-field {\n  background: #f0f9ff;\n}\n\n.salesforce-field {\n  background: #fef3c7;\n}\n\n.delete-mapping-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: #fee2e2;\n  color: #dc2626;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.delete-mapping-btn:hover {\n  background: #fecaca;\n  color: #b91c1c;\n}\n\n.add-mapping-section {\n  padding: 20px 30px;\n  border-top: 1px solid #e5e7eb;\n  background: #f8fafc;\n}\n\n.add-mapping-btn {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.add-mapping-btn:hover {\n  background: #2563eb;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.back-button,\n.continue-button {\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.back-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.continue-button {\n  background: #3b82f6;\n  color: white;\n  border: 1px solid #3b82f6;\n}\n\n.continue-button:hover {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .map-fields {\n    padding: 20px;\n  }\n\n  .field-headers,\n  .field-mapping-row {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .field-headers {\n    text-align: center;\n  }\n\n  .field-mapping-row {\n    position: relative;\n    padding-bottom: 60px;\n  }\n\n  .delete-mapping-btn {\n    position: absolute;\n    bottom: 15px;\n    right: 30px;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n\n  .back-button,\n  .continue-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
